export default __webpack_public_path__ + "static/media/logo-muis.8f988aea.png";